import React from 'react'
import styled from 'styled-components'
import type {LayoutProps, StyleProps} from '../../'
import convertLayoutProps from '../../utils/convertLayoutProps'

export interface BoxProps
  extends LayoutProps,
    React.HTMLAttributes<HTMLElement>,
    React.RefAttributes<HTMLElement> {
  as?: React.ElementType
  $styles?: StyleProps
  children?: React.ReactNode
  className?: string
}

const BoxBase = React.forwardRef<HTMLElement, BoxProps>(
  ({as: Element = 'div', children, ...props}, ref) => {
    return (
      <Element ref={ref} {...props}>
        {children}
      </Element>
    )
  },
)

BoxBase.displayName = 'BoxBase'

const Box = styled(BoxBase)<BoxProps>(({theme, $styles, ...props}) => {
  return theme.normalizeStyles({...convertLayoutProps(props), ...$styles})
})

export default Box
